module.exports = __webpack_public_path__ + "static/media/wants_to_create_seller_profile.edbed1fa.png";